import React from 'react';

import Img from '../../Img';

import styles from './upgrade.scss';

const ListItem = props => {
    return (
        <div className={`d-flex flex-row ${styles.listItem}`}>
            <div>
                <Img src={'/img/v2/icons/icon-valid-blue.svg'} />
            </div>
            <div>
                <p className="text" dangerouslySetInnerHTML={{ __html: props.children }} />
            </div>
        </div>
    );
};

export default ListItem;
